import * as Sentry from '@sentry/react';

// Mirrors the Snowplow gating convention in src/index.tsx (SnowplowScript
// only renders when REACT_APP_DEPLOYED_TO is set), so Sentry stays silent
// locally and only reports from deployed (staging/production) environments.
export function initSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  const environment = process.env.REACT_APP_DEPLOYED_TO;

  if (!dsn || !environment) return;

  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: 0,
    beforeSend(event) {
      if (event.request?.url) {
        try {
          const url = new URL(event.request.url);
          if (url.searchParams.has('customer_uuid')) {
            url.searchParams.set('customer_uuid', '[Filtered]');
            event.request.url = url.toString();
          }
        } catch {
          // malformed URL, leave as-is
        }
      }
      return event;
    },
  });
}

export function setSentryUser(travelRequestUuid?: string): void {
  Sentry.setUser(travelRequestUuid ? { id: travelRequestUuid } : null);
}

export function captureError(
  error: unknown,
  category: string,
  tags: Record<string, string> = {},
  extra?: Record<string, unknown>
): void {
  Sentry.captureException(error, {
    tags: { error_category: category, ...tags },
    extra,
  });
}

export function captureMessage(
  message: string,
  category: string,
  tags: Record<string, string> = {},
  extra?: Record<string, unknown>
): void {
  Sentry.captureMessage(message, {
    level: 'info',
    tags: { error_category: category, ...tags },
    extra,
  });
}
